// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__3QLm3","sidebar":"layout_sidebar__rU0oh","outlet":"layout_outlet__VHWvD"};